"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.findReasonableGridDuration = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var mins = 1000 * 60;
var hours = 60 * mins;
var days = 24 * hours;
var weeks = 7 * days;
var months = 30 * days;
var years = 12 * months;
var timeIntervals = [["1 ns", 0.000001], ["10 ns", 0.00001], ["100 ns", 0.0001], ["1 us", 0.001], ["10 us", 0.01], ["100 us", 0.1], ["1 ms", 1], ["5 ms", 5], ["50 ms", 50], ["500 ms", 500], ["1s", 1000], ["10s", 10000], ["1 min", mins], ["30 min", 30 * mins], ["1 hr", hours], ["8 hrs", 8 * hours], ["1 day", days], ["1 week", weeks], ["1 month", months], ["3 months", months * 3], ["1 year", years]];

var findReasonableGridDuration = function findReasonableGridDuration(duration) {
  var bestFittingIntervalIndex = 0;
  var bestFittingIntervalScore = -Infinity;

  for (var _i = 0, _Object$entries = Object.entries(timeIntervals); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        i = _Object$entries$_i[0],
        _Object$entries$_i$ = _slicedToArray(_Object$entries$_i[1], 2),
        timeInterval = _Object$entries$_i$[1];

    var timeIntervalScore = -1 * Math.abs(duration / timeInterval - 5);

    if (timeIntervalScore > bestFittingIntervalScore) {
      bestFittingIntervalIndex = i;
      bestFittingIntervalScore = timeIntervalScore;
    }
  }

  return [timeIntervals[bestFittingIntervalIndex], timeIntervals[bestFittingIntervalIndex - 1]];
};

exports.findReasonableGridDuration = findReasonableGridDuration;

var _default = function _default(transformMatrix, graphWidth) {
  var _transformMatrix$inve = transformMatrix.inverse().applyToPoint(0, 0),
      startTimeOnGraph = _transformMatrix$inve.x;

  var _transformMatrix$inve2 = transformMatrix.inverse().applyToPoint(graphWidth, 0),
      endTimeOnGraph = _transformMatrix$inve2.x;

  var visibleDuration = endTimeOnGraph - startTimeOnGraph;

  var _findReasonableGridDu = findReasonableGridDuration(endTimeOnGraph - startTimeOnGraph),
      _findReasonableGridDu2 = _slicedToArray(_findReasonableGridDu, 2),
      _findReasonableGridDu3 = _slicedToArray(_findReasonableGridDu2[0], 2),
      majorDurationLabel = _findReasonableGridDu3[0],
      majorDuration = _findReasonableGridDu3[1],
      _findReasonableGridDu4 = _slicedToArray(_findReasonableGridDu2[1], 2),
      minorDurationLabel = _findReasonableGridDu4[0],
      minorDuration = _findReasonableGridDu4[1];

  var numberOfMajorGridLines = Math.ceil((endTimeOnGraph - startTimeOnGraph) / majorDuration);
  var numberOfMinorGridLines = Math.ceil((endTimeOnGraph - startTimeOnGraph) / minorDuration);
  var majorGridLineStartTime = Math.floor(startTimeOnGraph / majorDuration) * majorDuration;
  var minorGridLineStartTime = Math.floor(startTimeOnGraph / minorDuration) * minorDuration;
  var majorGridLinePixelOffset = transformMatrix.applyToPoint(majorGridLineStartTime, 0).x;
  var minorGridLinePixelOffset = transformMatrix.applyToPoint(minorGridLineStartTime, 0).x;
  var majorGridLinePixelDistance = transformMatrix.applyToPoint(majorDuration, 0).x - transformMatrix.applyToPoint(0, 0).x;
  var minorGridLinePixelDistance = transformMatrix.applyToPoint(minorDuration, 0).x - transformMatrix.applyToPoint(0, 0).x;
  return {
    visibleDuration: visibleDuration,
    startTimeOnGraph: startTimeOnGraph,
    endTimeOnGraph: endTimeOnGraph,
    majorDuration: majorDuration,
    majorDurationLabel: majorDurationLabel,
    minorDuration: minorDuration,
    minorDurationLabel: minorDurationLabel,
    numberOfMajorGridLines: numberOfMajorGridLines,
    numberOfMinorGridLines: numberOfMinorGridLines,
    majorGridLinePixelOffset: majorGridLinePixelOffset,
    minorGridLinePixelOffset: minorGridLinePixelOffset,
    majorGridLinePixelDistance: majorGridLinePixelDistance,
    minorGridLinePixelDistance: minorGridLinePixelDistance
  };
};

exports.default = _default;